<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>购买反馈</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <date-components start-prop="rq" :start-date="listParams.rq" @set-start-date="getStartDate" date-width="100%" date-type="date" show-type="left" label-name="反馈日期："> </date-components>
          </el-col>

          <el-col :span="8">
            <el-form-item label="菜品名称：" prop="goodName">
              <el-input size="small" placeholder="请输入菜品名称" v-model="listParams.goodName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="exportExcel">-->
          <!--导出-->
          <!--</el-button>-->
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <!--<el-table-column-->
        <!--align="center"-->
        <!--width="60"-->
        <!--label="序号">-->
        <!--<template slot-scope="scope">-->
        <!--<span-->
        <!--v-text="(pager.pageIndex > 1 ?-->
        <!--(pager.pageIndex-1) * pager.pageSize :-->
        <!--0) + scope.$index + 1">-->
        <!--</span>-->
        <!--</template>-->
        <!--</el-table-column>-->

        <el-table-column prop="rq" align="center" label="反馈日期">
          <template slot-scope="scope">
            <span>{{ scope.row.rq | formatDate }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="appUserName" align="center" label="用户名"> </el-table-column>

        <el-table-column prop="plaGoodName" align="center" label="菜品名称"> </el-table-column>

        <el-table-column prop="wantBuyNum" align="center" label="菜品数量"> </el-table-column>

        <el-table-column prop="siteName" align="center" label="供应点"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        rq: "",
        goodName: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      queryChanged: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 父组件获取子组件传递的开始日期
     * @param startAttr
     * @param startDate
     */
    getStartDate(startAttr, startDate) {
      if (startDate !== "") {
        this.listParams[startAttr] = new Date(startDate).getTime();
      } else {
        this.listParams[startAttr] = "";
      }
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      if (this.queryChanged) {
        this.pager.pageIndex = 1;
      }
      this.$http({
        url: global.apiUrl + "/farmgoods/wantToBuy/findByPage",
        method: "GET",
        params: {
          rq: this.listParams.rq,
          goodName: this.listParams.goodName,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.queryChanged = false;
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.queryChanged = false;
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 导出excel
     */
    exportExcel() {},
  },
  watch: {
    "listParams.rq": function (val, oldVal) {
      if (val !== oldVal) {
        this.queryChanged = true;
      } else {
        this.queryChanged = false;
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
